
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: boolean;
}

export default function Card({ 
  children, 
  className = '', 
  padding = 'md',
  shadow = true 
}: CardProps) {
  const paddingClasses = {
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  
  return (
    <div className={`bg-white rounded-lg ${shadow ? 'shadow-sm' : ''} ${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
}
